
class NumberInput extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        console.log(this);
        const input = this.querySelector('input.custom-attribute__input');
        this.input = this.querySelector('input#custom-properties__input');
        this.errorMessage = this.dataset.errorMessage;

        const productForm = document.querySelector('[data-product-form-outer] form');
        const addToCartBtn = productForm.querySelector('button[type="submit"]');

        this.errorDisplay = productForm.querySelector('[data-error-display-attribute]');

        productForm.addEventListener('submit', this.handleSubmit.bind(this));
        addToCartBtn.addEventListener('click', this.handleSubmit.bind(this));

        if (input) {
            input.addEventListener('input', this.validateNumberInput.bind(this));
            input.addEventListener('focusout', this.handleInputLeave.bind(this));
        }

        this.observeProductSubmit();
        this.registerExistingQuickSubmitButtons();
    }

    handleSubmit(e) {
        const hasInputValue = this.input.value;
        const errorEl = this.errorDisplay.querySelector('.errors');

        if (!hasInputValue) {
            e.preventDefault();
            errorEl.innerHTML = this.errorMessage;
            this.showEl(this.errorDisplay);
            setTimeout(() => {
                this.hideEl(this.errorDisplay);
                errorEl.innerHTML = '';
            }, 5000);
        }
    }

    showEl(el) {
        if (el) {
            el.style.display = 'block';
            const contentHeight = el.scrollHeight + 'px';

            requestAnimationFrame(() => {
                el.style.height = contentHeight;
                el.style.marginTop = '20px';
                el.style.marginBottom = '20px';
            });

            el.addEventListener('transitionend', function transitionEnd() {
                el.removeEventListener('transitionend', transitionEnd);
            });
        }
    }

    hideEl(el) {
        const currentHeight = el.scrollHeight + 'px';
        el.style.height = currentHeight;
        requestAnimationFrame(() => {
            el.style.height = '0';
            el.style.marginTop = '0';
            el.style.marginBottom = '0';
        });

        el.addEventListener('transitionend', function transitionEnd() {
            el.style.display = 'none';
            el.removeEventListener('transitionend', transitionEnd);
        });
    }

    validateNumberInput(event) {
        const input = event.target;
        let value = parseFloat(input.value);
        const prefix = input.getAttribute("data-placeholder");

        if (value < 2) value = 2;
        if (value > 15) value = 15;

        const truncatedValue = Math.floor(value * 100) / 100;
        if (isNaN(value)) {
            this.input.removeAttribute('value');
            return;
        }

        if (value !== truncatedValue) {
            input.value = truncatedValue.toFixed(2);
            this.input.value = `${prefix} ${truncatedValue.toFixed(2)}`;
        } else if (input.value.split('.')[1]?.length > 2) {
            input.value = truncatedValue.toFixed(2);
            this.input.value = `${prefix} ${truncatedValue.toFixed(2)}`;
        } else {
            this.input.value = `${prefix} ${value}`;
        }

        this.updateValidationCheckerVisibility(true);
    }

    handleInputLeave(event) {
        const input = event.currentTarget;
        const value = parseFloat(input.value);
        const min = parseFloat(input.getAttribute("min"));
        const max = parseFloat(input.getAttribute("max"));
        const prefix = input.getAttribute("data-placeholder");

        if (value < min) {
            input.value = min;
            this.input.value = `${prefix} ${min}`;
        }

        if (value > max) {
            input.value = max;
            this.input.value = `${prefix} ${max}`;
        }

        this.updateValidationCheckerVisibility(!isNaN(value));
    }

    updateValidationCheckerVisibility(isValid) {
        const quickSubmitElement = document.querySelector('.product__submit__quick');
        if (quickSubmitElement) {
            const spans = quickSubmitElement.querySelectorAll('.validation-checker');
            spans.forEach((span) => {
                if (isValid) {
                    span.classList.add('hidden');
                } else {
                    span.classList.remove('hidden');
                }
            });
        }
    }

    observeProductSubmit() {
        const targetNode = document.querySelector('.product__submit');
        if (targetNode) {
            const config = { childList: true, subtree: true };

            const callback = (mutationsList) => {
                for (const mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        this.createSpanForQuickSubmitButtons();
                    }
                }
            };

            const observer = new MutationObserver(callback);
            observer.observe(targetNode, config);
        }
    }

    createSpanForQuickSubmitButtons() {
        const quickSubmitElement = document.querySelector('.product__submit__quick');
        if (quickSubmitElement) {
            const buttons = quickSubmitElement.querySelectorAll('[role="button"], button[type="button"]');
            buttons.forEach((button) => {
                const siblingValidationChecker = Array.from(button.parentElement.children).find(
                    (sibling) => sibling !== button && sibling.classList.contains('validation-checker')
                );
                if (!siblingValidationChecker) {
                    const span = document.createElement('span');
                    span.classList.add('validation-checker');
                    button.parentElement.appendChild(span);
                    span.addEventListener('click', this.handleValidationCheckerClick.bind(this));
                }
            });
        }
    }

    handleValidationCheckerClick(event) {
        const hasInputValue = this.input.value;
        const errorEl = this.errorDisplay.querySelector('.errors');

        if (!hasInputValue) {
            event.preventDefault();
            errorEl.innerHTML = this.errorMessage;
            this.showEl(this.errorDisplay);
            setTimeout(() => {
                this.hideEl(this.errorDisplay);
                errorEl.innerHTML = '';
            }, 5000);
        }
    }

    registerExistingQuickSubmitButtons() {
        this.createSpanForQuickSubmitButtons();
    }

    disconnectedCallback() {
        const input = this.querySelector('input');
        if (input) {
            input.removeEventListener('input', this.validateNumberInput.bind(this));
        }
    }
}

customElements.define('number-input', NumberInput);
